import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'

export interface IGetEncryptedTokenResponse {
    encryptedToken: string
}

export const makeCrossFrameIhmIdentityBrokerEncryptedTokenRetrieverRequest =
  async (): Promise<IGetEncryptedTokenResponse> => {
      return CrossFrameUtils.sendMessageToOtherFrame<IGetEncryptedTokenResponse>({
          frame: window,
          message: {
              method: 'fetchIhmIdentityBrokerEncryptedToken',
              data: {},
          },
      })
  }
